var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00206375 1.13526C0.00154305 0.87047 0.0943365 0.613858 0.264338 0.40997C0.360067 0.295217 0.477637 0.200361 0.610312 0.130833C0.742986 0.0613047 0.888156 0.0184714 1.03751 0.00478626C1.18687 -0.0088989 1.33747 0.00683311 1.4807 0.0510809C1.62393 0.0953286 1.75697 0.167222 1.8722 0.262645L7.98436 5.33967L14.1079 0.443969C14.2246 0.349833 14.3588 0.279534 14.5028 0.237114C14.6469 0.194694 14.798 0.180989 14.9474 0.196785C15.0968 0.212582 15.2416 0.257569 15.3735 0.329162C15.5054 0.400755 15.6217 0.497541 15.7158 0.613958C15.8196 0.731212 15.8979 0.868525 15.9458 1.01728C15.9937 1.16604 16.0101 1.32302 15.994 1.47838C15.978 1.63375 15.9298 1.78413 15.8524 1.9201C15.7751 2.05608 15.6704 2.1747 15.5447 2.26853L8.70277 7.7422C8.49873 7.90888 8.24279 8 7.97866 8C7.71453 8 7.45859 7.90888 7.25455 7.7422L0.412581 2.07587C0.274582 1.96218 0.165493 1.81777 0.0941668 1.65434C0.0228405 1.49091 -0.00871277 1.31308 0.00206375 1.13526Z",
    fill: "#3D3B3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a25913516532348bdf4ef11056b3ca52.svg";
export { ForwardRef as ReactComponent };